import React from "react";

function formikTextErrors(props) {
  return <div className="error">{props.children}</div>;
}

export default formikTextErrors;
